'use client';
import React from 'react';
import { GradeLevel } from '@/lib/worksheetData';
import { useWorksheetStore } from './worksheetStore';

const GRADES: GradeLevel[] = ['K', 'Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6', 'Grade 7', 'Grade 8'];

export default function GradeFilterBar() {
  const { selectedGrade, setSelectedGrade } = useWorksheetStore();

  const options: (GradeLevel | 'All')[] = ['All', ...GRADES];

  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label="Filter by grade">
      {options.map((grade) => {
        const isActive = selectedGrade === grade;
        return (
          <button
            key={grade}
            onClick={() => setSelectedGrade(grade as GradeLevel | 'All')}
            className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-150 scale-press ${
              isActive
                ? 'bg-violet-600 text-white shadow-sm'
                : 'bg-card border border-border text-muted-foreground hover:border-violet-400 hover:text-violet-600'
            }`}
          >
            {grade === 'All' ? 'All Grades' : grade}
          </button>
        );
      })}
    </div>
  );
}
